import { Box, LegacyText, font, themedColor } from '@lemonade-hq/cdk';
import styled from 'styled-components';

export const Subtitle = styled(LegacyText).attrs({
  as: 'h5',
  mt: 18,
  mb: 60,
  type: 'main',
})`
  ${font('main', { fontSize: '20px', fontWeight: 400 })}
  transition: opacity 0.3s ease;
  opacity: 1;
`;

export const PrimaryText = styled.span`
  color: ${themedColor('primary')};
  font-weight: 700;
`;

export const GreenText = styled.span`
  color: ${themedColor('green')};
  font-weight: 700;
`;

export const MessageContainer = styled(Box).attrs({
  top: [0, 70],
})`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: ${themedColor('night')};
  max-width: 930px;
  transition:
    opacity 0.3s ease,
    transform 0.5s ease;
  opacity: 1;
`;

export const ShoutoutContainer = styled(MessageContainer)`
  top: 160px;

  &.enter {
    opacity: 0;
    transform: translateY(-100%);
  }
  &.enter-active {
    opacity: 1;
    transform: translateY(0);
  }
  &.exit-active {
    opacity: 0;
    transform: translateY(0);
  }
`;

export const GameOnTitle = styled(LegacyText).attrs({
  as: 'h2',
  type: 'main',
})`
  ${font('main', { fontSize: '56px', fontWeight: 700, lineHeight: '66px' })}
  margin: 0;
  text-transform: uppercase;
`;

export const Shoutout = styled(GameOnTitle)`
  position: absolute;
  width: 100%;
  text-align: center;
  text-transform: uppercase;

  transition:
    opacity 300ms ease,
    transform 300ms ease;
  opacity: 1;
  transform: translateX(-50%) scale(1);

  &.enter {
    opacity: 0;
  }
  &.enter-active {
    opacity: 1;
  }
  &.exit-active {
    opacity: 0;
    transform: translateX(-50%) scale(1.5);
  }
`;

export const InvisiButton = styled.button`
  border: none;
  position: absolute;
  cursor: pointer;
  outline: none;

  @-moz-document url-prefix() {
    cursor: default;
  }
`;
